import { Grid } from "@material-ui/core";

import useClienteBodyController from "../../controllers/ClientesBodyController";
import SwitchesContainer from "../../commons/SwitchesContainer";
import { TabHeader } from "../../commons/TabHeader";

const TabGuias = () => {
  const { switches } = useClienteBodyController();

  return (
    <>
      <TabHeader
        title="Visualização das guias no Cadastro de Clientes"
        subtitle="Defina quais guias serão exibidas no cadastro de clientes."
      />

      <Grid container direction="column">
        {switches.map(({ ...props }) => (
          <SwitchesContainer {...props} />
        ))}
      </Grid>
    </>
  );
};

export default TabGuias;
